import { SvgCurve, SvgTxt } from "./DrawMtrlCurve";
import { MaterialRecord, MaterialSvg } from "./Material";

function ReinfCurve(activeMtrl: MaterialRecord, svg: MaterialSvg): [SvgCurve[], SvgTxt[]] {
  const name = activeMtrl["name"].toString();
  const E = activeMtrl["units"]["elasticityModulus"] / 1e9; //Gpa

  const yieldS = activeMtrl["units"]["yieldStrength"] / 1e6; //Mpa
  const yieldE = Number((yieldS / E).toFixed(1)); // promille

  let ultimateS = activeMtrl["units"]["ultimateStrength"] / 1e6; //Mpa
  let ultimateE = activeMtrl["units"]["epsilonUltimate"] * 1.0e3; // promille

  const scaleW = svg.max.x / ultimateE;
  const scaleH = svg.max.y / ultimateS;

  // stress-strain curve --------------------------------

  let curve1: SvgCurve = {
    stroke: "red",
    width: "0.5",
    dash: "",
    data: "",
  };

  curve1.data = "M" + svg.origo.x.toString() + "," + svg.origo.y.toString() + " ";

  curve1.data += "l" + (yieldE * scaleW).toString() + "," + (-yieldS * scaleH).toString();
  curve1.data += "l" + ((ultimateE - yieldE) * scaleW).toString() + "," + (-(ultimateS - yieldS) * scaleH).toString();

  // 'fyk'-line  --------------------------------

  let curve2: SvgCurve = {
    stroke: "black",
    width: "0.5",
    dash: "5,5",
    data: "",
  };

  curve2.data = "M" + (svg.origo.x - 5).toString() + "," + (svg.origo.y - yieldS * scaleH).toString() + " ";
  curve2.data += "l" + (yieldE * scaleW + 5).toString() + ",0";

  // 'eps_y'-line  --------------------------------

  let curve3: SvgCurve = {
    stroke: "black",
    width: "0.5",
    dash: "5,5",
    data: "",
  };

  curve3.data = "M" + (svg.origo.x + yieldE * scaleW).toString() + "," + (svg.origo.y + 5).toString() + " ";
  curve3.data += "l" + "0," + (-(yieldS * scaleH + 5)).toString();

  // 'eps_u'-line  --------------------------------

  let curve4: SvgCurve = {
    stroke: "black",
    width: "1",
    dash: "5,5",
    data: "",
  };

  curve4.data = "M" + (svg.origo.x + ultimateE * scaleW).toString() + "," + (svg.origo.y + 5).toString() + " ";
  curve4.data += "l" + "0," + (-(ultimateS * scaleH + 5)).toString();

  // 'fuk'-line  --------------------------------

  let curve5: SvgCurve = {
    stroke: "black",
    width: "1",
    dash: "5,5",
    data: "",
  };

  curve5.data = "M" + (svg.origo.x - 5).toString() + "," + (svg.origo.y - ultimateS * scaleH).toString() + " ";
  curve5.data += "l" + (ultimateE * scaleW + 5).toString() + ",0";

  //---- collect curves -----------------

  let curves = [curve1, curve2, curve3, curve5];

  //---- texts -----------------
  let txts: SvgTxt[] = [
    {
      x: (svg.origo.x + svg.max.x / 2 - (name.length * 10) / 2).toString(),
      y: (svg.origo.y - svg.max.y - 20).toString(),
      style: {
        fontSize: "22px",
        fontStyle: "normal",
      },
      text: "" + name + "",
    },

    {
      x: (svg.origo.x + yieldE * scaleW).toString(),
      y: (svg.origo.y + 15).toString(),
      style: {
        fontSize: "22px",
        fontStyle: "italic",
      },
      text: "&epsilon;&#x1D67;",
    },

    {
      x: (svg.origo.x + ultimateE * scaleW).toString(),
      y: (svg.origo.y + 15).toString(),
      style: {
        fontSize: "22px",
        fontStyle: "italic",
      },
      text: "&epsilon;&#x1D64;",
    },

    {
      x: (svg.origo.x - 30).toString(),
      y: (svg.origo.y - yieldS * scaleH).toString(),
      style: {
        fontSize: "20px",
        fontWeight: "normal",
        fontStyle: "italic",
      },
      text: "f&#x1D64;|&#x1D67;",
    },

    // {
    //   x: (svg.origo.x - 30 + pad).toString(),
    //   y: (svg.origo.y - ultimateS * scaleH - yPad).toString(),
    //   style: {
    //     fontSize: "20px",
    //     fontWeight: "bold",
    //     fontStyle: "italic",
    //   },
    //   text: "f",
    // },
    // {
    //   x: (svg.origo.x - 25 + pad).toString(),
    //   y: (svg.origo.y + 5 - ultimateS * scaleH - yPad).toString(),
    //   style: {
    //     fontSize: "15px",
    //     fontWeight: "bold",
    //     fontStyle: "italic",
    //   },
    //   text: "u",
    // },

    {
      x: (svg.origo.x + svg.max.x / 2 - 40).toString(),
      y: (svg.origo.y - svg.max.y / 2 - 35).toString(),
      style: {
        fontSize: "20px",
        fontStyle: "italic",
      },
      text: "E = " + E.toString() + " GPa",
    },

    {
      x: (svg.origo.x + svg.max.x / 2 - 40).toString(),
      y: (svg.origo.y - svg.max.y / 2 - 15).toString(),
      style: {
        fontSize: "20px",
        fontStyle: "italic",
      },
      text: "f&#x1D64; = " + ultimateS.toString() + " MPa",
    },

    {
      x: (svg.origo.x + svg.max.x / 2 - 40).toString(),
      y: (svg.origo.y - svg.max.y / 2 + 5).toString(),
      style: {
        fontSize: "20px",
        fontStyle: "italic",
      },
      text: "f&#x1D67;    = " + yieldS.toString() + " MPa",
    },

    {
      x: (svg.origo.x + svg.max.x / 2 - 40).toString(),
      y: (svg.origo.y - svg.max.y / 2 + 25).toString(),
      style: {
        fontSize: "20px",
        fontStyle: "italic",
      },
      text: "&epsilon;&#x1D67;    = " + yieldE.toString() + " &permil;",
    },

    {
      x: (svg.origo.x + svg.max.x / 2 - 40).toString(),
      y: (svg.origo.y - svg.max.y / 2 + 45).toString(),
      style: {
        fontSize: "20px",
        fontStyle: "italic",
      },
      text: "&epsilon;&#x1D64;     = " + ultimateE.toString() + " &permil;",
    },
  ];

  return [curves, txts];
}

export default ReinfCurve;
